<template>
  <div class="Choices"> 
    <div class="Choices__container">
      <Title/>  
      <div class="Choices__block">
        <Choice ref="voice" indice="voice"/>
        <div class="Choices__space"/>
        <Choice ref="words" indice="words"/>
      </div>
    </div>
  </div> 
</template>

<script>

import gsap from "gsap"
import Choice from "./assets/Choice.vue"
import Title from "./assets/Title.vue"

export default {

  name: 'Choices',
  components: { Choice, Title },
  mounted() {
    const delay = this.$root.route.from.params.section == 'weave' ? 1 : .1
    this.$nextTick(()=>{
      gsap.from([ this.$refs.voice.$el, this.$refs.words.$el ], {
        duration: .5, 
          y: '+=300%', 
          ease: 'cubic.out', 
          stagger: .2,
          delay: delay, 
      })
    })
  },

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Choices
  position absolute
  top 0
  left 0
  color white
  width 100%
  height 100%

  &__container
    width 100%
    height 100%
    display flex 
    flex-direction column
    justify-content flex-start
    align-items center

  &__block 
    width 100%
    display flex 
    flex-direction column
    justify-content flex-start
    align-items center
    padding-top 8%

  &__space
    height 4%


</style>


